"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mentionOptions = exports.mentionBoxPlugin = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _contentConverter = require("@insided/shared/uikit/Editor/contentConverter");

var _getInsidedData, _getInsidedData$topic;

var getAvatar = function getAvatar(user) {
  var avatar = user.avatar,
      name = user.name,
      id = user.id;

  if (avatar) {
    return "<div class=\"profilepicture\"><img src=".concat(avatar, " alt=").concat(name, " /></div>");
  }

  return "<div class='profilepicture'>\n      <div class='default-avatar avatar-variant-".concat(id % 10, "'>\n        ").concat(name[1].toUpperCase() || '', "\n      </div>\n    </div>");
};

var topicId = (_getInsidedData = (0, _insidedDataStorage.getInsidedData)('content')) === null || _getInsidedData === void 0 ? void 0 : (_getInsidedData$topic = _getInsidedData.topic) === null || _getInsidedData$topic === void 0 ? void 0 : _getInsidedData$topic.id;
var mentionOptions = {
  feeds: [{
    marker: '@',
    pattern: topicId ? /@.{0,30}$/ : /@.{2,30}$/,
    outputTemplate: "&#8203;<user-mention data-id={id}>{name}</user-mention>&nbsp;",
    itemTemplate: function itemTemplate(user) {
      return "<li data-id=\"{id}\" data-name=".concat(user.name.slice(1), " class='mention-user'><div class='avatar avatar--S'>").concat(getAvatar(user), "</div>").concat(user.name.slice(1), "</li>");
    },
    feed: function () {
      var _feed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(opt, callback) {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get("/member/_searchUser?query=".concat(opt.query.toLowerCase(), "&topic_id=").concat(topicId || ''));

              case 2:
                res = _context.sent;
                callback(res.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function feed(_x, _x2) {
        return _feed.apply(this, arguments);
      }

      return feed;
    }(),
    minChars: topicId ? 0 : 2
  }]
};
exports.mentionOptions = mentionOptions;
var mentionBoxPlugin = {
  requires: 'widget',
  onLoad: function onLoad() {
    var dtd = window.CKEDITOR.dtd;

    for (var name in dtd) {
      if (!name.includes('$')) {
        dtd[name]['user-mention'] = 1;
      }
    }
  },
  init: function init(editor) {
    editor.widgets.add('mention-box', {
      upcast: function upcast(elem) {
        return elem.name === 'user-mention';
      },
      inline: true
    });
    editor.addCommand('mention', {
      editorFocus: true,
      exec: function exec(editor, data) {
        editor.insertHtml((0, _contentConverter.toEditorFormat)("<user-mention data-id=".concat(data.id, ">").concat(data.username, "</user-mention>&nbsp;")));
        return true;
      }
    });
  }
};
exports.mentionBoxPlugin = mentionBoxPlugin;